import React, { Component } from "react";
import { Toolbar, AppBar, List, ListItem, ListItemIcon, Icon, ListItemText, IconButton, SwipeableDrawer, Button, Grid, Divider } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";

import { Link } from "../../../routing";
import Screen from "../../components/Screen";

import "./Layout.styl";
import Text from "../../components/Text";
import BackToTopButton from "../../components/BackToTopButton";
import Preloader from "../../components/Preload";
import env from "../../../env";
// import ContactFormDialog from "../../components/ContactFormDialog";

export default class Layout extends Component {
    displayName = Layout.name

    state = { drawerOpen: false, isFooterDialogOpen: false };
    mergeState = (newState) => this.setState(oldState => ({ ...oldState, ...newState }));
    openDrawer = () => this.mergeState({ drawerOpen: true });
    closeDrawer = () => this.mergeState({ drawerOpen: false });
    toggleDrawer = () => this.mergeState({ drawerOpen: !this.state.drawerOpen });
    openFooterDialog = () => this.mergeState({ isFooterDialogOpen: true });
    closeFooterDialog = () => this.mergeState({ isFooterDialogOpen: false });

    /* icones devem ser retirados de https://material.io/tools/icons */
    buttons = [
        { text: "Início", icon: "local_cafe", link: "home", showInAppBar: true, showInDrawer: true, showInFooter: false },
        { text: "Prefeituras", icon: "location_city", link: "cityHall", showInAppBar: true, showInDrawer: true, showInFooter: true },
        { text: "Empreiteiras", icon: "lightbulb", link: "contractor", showInAppBar: true, showInDrawer: true, showInFooter: true },
        { text: "Canais de Comunicação", icon: "perm_phone_msg", link: "communication", showInAppBar: true, showInDrawer: true, showInFooter: true },
        { text: "Notícias", icon: "ballot", link: "news", showInAppBar: true, showInDrawer: true, showInFooter: true },
    ];

    constructor(props) {
        super(props);
        this.drawerRef = React.createRef();
    }

    renderAppBarButtons = () => {
        return this.buttons.map((button, index) => {
            if (!button.showInAppBar) return null;
            
            let rendered = (
                <Button tabIndex={-1}>
                    <Icon className="icon">{button.icon}</Icon>
                    <Text tabIndex={-1} className="text">{button.text}</Text>
                </Button>
            );
            
            if (button.link) {
                rendered = <Link to={button.link}>{rendered}</Link>;
            }

            return <span key={index} className="button" aria-label={button.text}>{rendered}</span>;
        });
    }

    renderDrawerButtons = () => {
        return this.buttons.map((button, index) => {
            if (!button.showInDrawer) return null;
            
            let rendered = (
                <ListItem button onClick={this.closeDrawer}>
                    <ListItemIcon><Icon className="icon">{button.icon}</Icon></ListItemIcon>
                    <ListItemText><Text className="text">{button.text}</Text></ListItemText>
                </ListItem>
            );
            
            if (button.link) {
                rendered = <Link to={button.link} tabIndex={-1}>{rendered}</Link>;
            }

            return <div key={index}>{rendered}</div>;
        });
    }

    renderFooterButtons = () => {
        return this.buttons.map((button, index) => {
            if (!button.showInFooter) return null;

            let rendered = (
                <Button className="button" aria-label={button.text}>
                    <Icon className="icon">{button.icon}</Icon>
                    <Text tabIndex={-1} className="text">{button.text}</Text>
                </Button>
            );

            if (button.link) {
                rendered = <Link tabIndex={-1} to={button.link}>{rendered}</Link>;
            }

            return <div key={index}>{rendered}</div>;
        });
    }

    render() {
        return (
            <div className="Layout">
                <Preloader />
                <header>
                    <AppBar position="fixed" className="AppBar app background darker blue">
                        <Toolbar>
                            <IconButton aria-label="Expand Menu" onClick={this.toggleDrawer}>
                                <MenuIcon className="drawerMenuIcon" />
                            </IconButton>
                            <div className="geolux">
                                <Link to="home">
                                    <img src={env.images.geoluxLogo} alt="Logo do Geolux" />
                                </Link>
                            </div>
                            <Screen notebook>
                            { this.renderAppBarButtons() }
                            </Screen>
                        </Toolbar>
                        <SwipeableDrawer variant="temporary" open={this.state.drawerOpen} onClose={this.closeDrawer} onOpen={this.openDrawer}>
                            <div ref={this.drawerRef} className="drawer app background darker blue" tabIndex={0} aria-label="Opções do menu" onKeyDown={this.closeDrawer}>
                                <List>
                                    <ListItem>
                                        <div className="wide flex jc-c">
                                            <h1 className="geolux-font">geolux</h1>
                                        </div>
                                    </ListItem>
                                    { this.renderDrawerButtons() }
                                </List>
                            </div>
                        </SwipeableDrawer>
                    </AppBar>
                </header>
                <main>
                {this.props.children}
                </main>
                <footer tabIndex={0} aria-label="Rodapé" className="app background darker blue">
                    <div className="marketing">
                        <Text as="h1" className="geolux-font">geolux</Text>
                        <Text className="text">Sua solução para a gestão da iluminação pública.</Text>
                    </div>
                    <Divider className="divider" />
                    <Grid container className="section-container">
                        <Grid item xs={12} sm={4} md={4} lg={3} xl={2} className="section">
                            <Text as="h1" className="uppercase">Continue navegando</Text>
                            {this.renderFooterButtons()}
                        </Grid>
                        <Grid item xs={12} sm={5} md={5} lg={3} xl={2} className="section">
                            <Text as="h1" className="uppercase">Entre em contato</Text>
                            <Button tabIndex={-1} className="button">
                                <Icon className="icon">email</Icon>
                                <Text as="a" className="text" href="mailto: contato@geolux.com.br">contato@geolux.com.br</Text>
                            </Button>
                            {/* <Button tabIndex={-1} className="button" onClick={this.openFooterDialog}>
                                <Icon className="icon">message</Icon>
                                <Text className="text">Formulário de contato</Text>
                            </Button>
                            <ContactFormDialog open={this.state.isFooterDialogOpen} onClose={this.closeFooterDialog} /> */}
                        </Grid>
                    </Grid>
                    <Divider />
                    <Text className="copyright align-center">&copy; {new Date().getFullYear()} Geolux. Desenvolvido por <a target="_blank" rel="noopener noreferrer external nofollow" href="http://www.sumersoft.com.br/">Sumersoft Tecnologia</a>.</Text>
                </footer>
                <BackToTopButton>Voltar ao Topo</BackToTopButton>
            </div>
        );
    }
}
